module.exports = __webpack_public_path__ + "img/btnRight.96a2d6b1.svg";